import { render, staticRenderFns } from "./SeguimientoAutomatico.vue?vue&type=template&id=fbafaba4"
import script from "./SeguimientoAutomatico.vue?vue&type=script&lang=js"
export * from "./SeguimientoAutomatico.vue?vue&type=script&lang=js"
import style0 from "./SeguimientoAutomatico.vue?vue&type=style&index=0&id=fbafaba4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports